import { useLocalHref, useUi } from "@/core/i18n/locale-context"

export interface RelatedLink {
  label: string
  href: string
}

/** "Read next" cards: the internal-link block shared by product pages, guides and tool pages (T528). */
export function RelatedLinks({
  links,
  title,
  id = "related-title",
}: {
  links: RelatedLink[]
  title?: string
  id?: string
}) {
  const ui = useUi()
  const localHref = useLocalHref()
  return (
    <section className="px-band grid gap-4 py-8" aria-labelledby={id}>
      <h2 id={id} className="text-2xl font-semibold">
        {title ?? ui.readNext}
      </h2>
      <ul className="grid gap-3 md:grid-cols-3">
        {links.map(({ label, href }) => (
          <li key={href}>
            <a
              href={localHref(href)}
              className="border-border bg-card focus-visible:ring-ring flex min-h-11 items-center rounded-lg border px-4 py-3 font-semibold outline-none focus-visible:ring-2"
            >
              {label}
            </a>
          </li>
        ))}
      </ul>
    </section>
  )
}
